import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase.config';

/**
 * Fetch all community appraisals/reviews for a given product
 */
export const fetchProductReviews = async (productId) => {
  if (!productId) return [];

  try {
    const reviewsRef = collection(db, 'reviews');
    const q = query(
      reviewsRef,
      where('productId', '==', productId)
    );

    const snapshot = await getDocs(q);
    const reviews = [];
    snapshot.forEach((doc) => {
      reviews.push({ id: doc.id, ...doc.data() });
    });

    // Sort descending by date
    return reviews.sort((a, b) => {
      const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt || 0);
      const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt || 0);
      return dateB - dateA;
    });
  } catch (error) {
    console.warn('Could not load remote reviews from Firestore, using static/local reviews:', error);
    return [];
  }
};

/**
 * Persist a new verified review for a product from a logged-in user
 */
export const addProductReview = async ({
  productId,
  userId,
  userName,
  userEmail,
  userPhoto,
  rating,
  text,
}) => {
  const newReview = {
    productId,
    userId,
    userName: userName || userEmail?.split('@')[0] || 'Verified Member',
    userPhoto: userPhoto || null,
    rating: Number(rating),
    text: text.trim(),
    createdAt: new Date().toISOString(),
    isVerifiedMember: true,
  };

  try {
    const docRef = await addDoc(collection(db, 'reviews'), {
      ...newReview,
      serverTime: serverTimestamp(),
    });
    return { id: docRef.id, ...newReview };
  } catch (error) {
    console.warn('Failed to persist review to Firestore, falling back to local session review:', error);
    return { id: `local-${Date.now()}`, ...newReview };
  }
};
